/* DHT Solutions - Add to Quote. Added 7 September 2026.

   Adds an "Add to Quote" button under Add to Cart on every product card, and
   opens a modal that sends the enquiry through Shopify's built-in contact
   form. No app and no backend needed.

   Two card layouts are supported:
     1. article.dht-card    - DHT's custom collection cards (dht-collection-main)
     2. product-card        - the stock Enterprise card (snippets/product-card.liquid)

   Done in JS rather than in the Liquid so the two large core card files are
   never rewritten. Delete this asset and the theme is exactly as it was.
   3 October 2026: the button now opens the product page's quote form when
   the template renders it (see openPdpModal below).
*/
(function () {
  'use strict';

  if (window.__dhtQuoteInit) return;
  window.__dhtQuoteInit = true;

  var dialog = null;
  var current = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleFrom(href) {
    if (!href) return '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function makeButton(title, handle, vendor) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dht-quote-btn';
    btn.setAttribute('data-dht-quote', '');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('data-product-title', title);
    btn.setAttribute('data-product-handle', handle);
    btn.setAttribute('data-product-vendor', vendor);
    btn.textContent = 'Add to Quote';
    return btn;
  }

  function injectButtons() {
    /* --- 1. DHT custom cards --- */
    var dhtCards = document.querySelectorAll('article.dht-card');

    Array.prototype.forEach.call(dhtCards, function (card) {
      if (card.querySelector('[data-dht-quote]')) return;

      var link = card.querySelector('a.dht-card__link');
      var titleEl = card.querySelector('.dht-card__title');
      var vendorEl = card.querySelector('.dht-card__vendor');
      var form = card.querySelector('form.dht-card__form');

      if (!titleEl) return;

      var title = titleEl.textContent.trim();
      var handle = handleFrom(link && link.getAttribute('href'));
      var vendor = vendorEl ? vendorEl.textContent.trim() : '';

      /* Made-to-order cards already end in a "Request a quote" link. Make that
         link open the quote form rather than adding a second quote button. */
      var quoteLink = card.querySelector('a.dht-card__cta');
      if (quoteLink) {
        quoteLink.setAttribute('data-dht-quote', '');
        quoteLink.setAttribute('aria-haspopup', 'dialog');
        quoteLink.setAttribute('data-product-title', title);
        quoteLink.setAttribute('data-product-handle', handle);
        quoteLink.setAttribute('data-product-vendor', vendor);
        return;
      }

      /* The card's own button classes, so it matches Add to cart exactly.
         It sits under the cart button, or under Sold out on a sold-out card. */
      var btn = makeButton(title, handle, vendor);
      btn.className = 'dht-btn dht-btn--quiet dht-card__cta dht-card__quote';

      (form ? form.parentElement : card).appendChild(btn);
    });

    /* --- 2. Stock Enterprise cards --- */
    var stockCards = document.querySelectorAll('product-card');

    Array.prototype.forEach.call(stockCards, function (card) {
      if (card.querySelector('[data-dht-quote]')) return;

      var holder = card.querySelector('.card__quick-add');
      var link = card.querySelector('.card__title a');
      var vendorEl = card.querySelector('.card__vendor');

      if (!holder || !link) return;

      var btn = makeButton(
        link.textContent.trim(),
        handleFrom(link.getAttribute('href')),
        vendorEl ? vendorEl.textContent.trim() : ''
      );
      btn.className = 'dht-quote-btn w-full';

      holder.appendChild(btn);
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    injectButtons();

    /* Collection pages filter and paginate without a reload. */
    if (window.MutationObserver) {
      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          injectButtons();
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  });

  /* ---------- the modal ---------- */

  function build() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'dht-quote-modal';
    dialog.setAttribute('aria-labelledby', 'dht-quote-title');
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    return dialog;
  }

  function render() {
    dialog.innerHTML =
      '<div class="dht-quote-modal__head">' +
        '<div>' +
          '<h2 class="dht-quote-modal__title" id="dht-quote-title">Request a quote</h2>' +
          '<p class="dht-quote-modal__product">' + esc(current.title) + '</p>' +
        '</div>' +
        '<button type="button" class="dht-quote-modal__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="dht-quote-modal__body">' +
        '<p class="dht-quote-error" hidden></p>' +
        '<form novalidate>' +
          '<div class="dht-quote-row">' +
            '<div class="dht-quote-field">' +
              '<label for="dhtq-name">Your name</label>' +
              '<input id="dhtq-name" name="name" type="text" autocomplete="name" required>' +
            '</div>' +
            '<div class="dht-quote-field">' +
              '<label for="dhtq-phone">Phone</label>' +
              '<input id="dhtq-phone" name="phone" type="tel" autocomplete="tel">' +
            '</div>' +
          '</div>' +
          '<div class="dht-quote-field">' +
            '<label for="dhtq-email">Email</label>' +
            '<input id="dhtq-email" name="email" type="email" autocomplete="email" required>' +
          '</div>' +
          '<div class="dht-quote-field">' +
            '<label for="dhtq-qty">Quantity</label>' +
            '<input id="dhtq-qty" name="qty" type="number" min="1" value="1">' +
          '</div>' +
          '<div class="dht-quote-field">' +
            '<label for="dhtq-msg">Anything we should know?</label>' +
            '<textarea id="dhtq-msg" name="message" placeholder="Delivery suburb, timing, power supply, or anything else."></textarea>' +
          '</div>' +
          '<p class="dht-quote-modal__fine">We will confirm availability and send you a price. No payment is taken now.</p>' +
          '<button type="submit" class="dht-quote-modal__submit">Send quote request</button>' +
        '</form>' +
      '</div>';

    dialog.querySelector('.dht-quote-modal__close').addEventListener('click', function () {
      dialog.close();
    });

    dialog.querySelector('form').addEventListener('submit', submit);
  }

  function submit(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var btn = form.querySelector('.dht-quote-modal__submit');
    var errEl = dialog.querySelector('.dht-quote-error');

    var name = form.name.value.trim();
    var email = form.email.value.trim();

    errEl.hidden = true;

    if (!name || !email) {
      errEl.textContent = 'Please add your name and email so we can reply.';
      errEl.hidden = false;
      return;
    }

    var page = current.handle
      ? window.location.origin + '/products/' + current.handle
      : 'not supplied';

    var body =
      'QUOTE REQUEST' + '\n\n' +
      'Product: ' + current.title + '\n' +
      'Brand: ' + (current.vendor || 'not supplied') + '\n' +
      'Product page: ' + page + '\n' +
      'Quantity: ' + (form.qty.value || '1') + '\n\n' +
      'Message:' + '\n' + (form.message.value.trim() || 'None');

    var data = new FormData();
    data.append('form_type', 'contact');
    data.append('utf8', '✓');
    data.append('contact[name]', name);
    data.append('contact[email]', email);
    data.append('contact[phone]', form.phone.value.trim());
    data.append('contact[body]', body);

    btn.disabled = true;
    btn.textContent = 'Sending...';

    fetch('/contact', { method: 'POST', body: data })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        dialog.querySelector('.dht-quote-modal__body').innerHTML =
          '<div class="dht-quote-modal__done">' +
            '<h3>Thanks, that is with us.</h3>' +
            '<p>We will check availability and come back to you with a price, usually the same business day.</p>' +
          '</div>';
      })
      .catch(function () {
        errEl.textContent = 'Sorry, that did not send. Please call (03) 9796 8925 or use the contact page.';
        errEl.hidden = false;
        btn.disabled = false;
        btn.textContent = 'Send quote request';
      });
  }

  /* ---------- the product-page quote form ----------
     Added 3 October 2026. sections/dht-quote-loader.liquid now renders the
     same quote form the product page uses (snippets/dht-quote-modal.liquid).
     When it is on the page, a card's button opens that form and fills in the
     card's product. The small modal above stays as the fallback for any page
     without it. */

  function textOf(root, sel) {
    var el = root && root.querySelector(sel);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function money(cents) {
    var n = Number(cents) / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function setField(form, name, value) {
    var el = form && form.querySelector('[name="contact[' + name + ']"]');
    if (el) el.value = value;
  }

  function bindPdpModal(dlg) {
    if (dlg.__dhtBound) return;
    dlg.__dhtBound = true;

    function shut() {
      dlg.close();
      document.body.classList.remove('dht-modal-open');
    }

    Array.prototype.forEach.call(dlg.querySelectorAll('[data-dht-close]'), function (b) {
      b.addEventListener('click', shut);
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) shut();
    });

    /* Escape closes the dialog natively. Watching the open attribute unlocks
       the page even where the close event is late (Chrome holds it back in a
       background tab), so the page can never stay scroll-locked. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (!dlg.open) document.body.classList.remove('dht-modal-open');
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    dlg.addEventListener('close', function () {
      document.body.classList.remove('dht-modal-open');
    });
  }

  function openPdpModal(dlg, btn) {
    var card = btn.closest('article.dht-card') || btn.closest('product-card') || document;
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    var title = current.title;
    var vendor = current.vendor;
    var price = textOf(card, '.dht-card__now');
    var url = link ? link.href.split('?')[0] : '';

    var heading = dlg.querySelector('#dht-quote-title');
    var form = dlg.querySelector('form');

    /* Same rule as the snippet: brand plus SKU, else the first words of the title. */
    function setLabel(sku) {
      var label = sku ? (vendor ? vendor + ' ' + sku : sku) : title.split(/\s+/).slice(0, 4).join(' ');
      if (heading) heading.textContent = 'Request a quote on this ' + label;
    }

    setLabel('');
    setField(form, 'Product', title);
    setField(form, 'SKU', '');
    setField(form, 'Price ex GST', price);
    setField(form, 'Product URL', url);

    /* The photo in the left panel shows this card's machine, or hides when
       the card has none, so it never shows the placeholder product. */
    var pic = dlg.querySelector('.dht-modal__pic');
    var picImg = pic && pic.querySelector('img');
    if (pic) pic.hidden = !img;
    if (img && picImg) {
      picImg.removeAttribute('srcset');
      picImg.src = img.currentSrc || img.src;
    }

    bindPdpModal(dlg);
    dlg.showModal();
    document.body.classList.add('dht-modal-open');

    /* The card does not carry the SKU, which the heading and the enquiry need. */
    if (current.handle && window.fetch) {
      var wanted = current.handle;
      fetch('/products/' + wanted + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || current.handle !== wanted) return;
          var v = (p.variants || [])[0] || {};
          if (v.sku) {
            setLabel(v.sku);
            setField(form, 'SKU', v.sku);
          }
          if (v.price != null) setField(form, 'Price ex GST', money(v.price));
        })
        .catch(function () {});
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-dht-quote]') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    current = {
      title: btn.getAttribute('data-product-title') || '',
      handle: btn.getAttribute('data-product-handle') || '',
      vendor: btn.getAttribute('data-product-vendor') || ''
    };

    var pdpModal = document.getElementById('dht-quote-modal');
    if (pdpModal && typeof pdpModal.showModal === 'function') {
      openPdpModal(pdpModal, btn);
      return;
    }

    build();
    render();

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      window.location.href = '/pages/contact';
    }
  });
})();
